import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEn from '@/locales/en/common.json';
import campaignEn from '@/locales/en/campaign.json';
import errorEn from '@/locales/en/error.json';
import faqEn from '@/locales/en/faq.json';
import validationEn from '@/locales/en/validation.json';
import poweredEn from '@/locales/en/powered.json';
import marketingEn from '@/locales/en/marketing.json';
import glossaryEn from '@/locales/en/glossary.json';
import tableEn from '@/locales/en/table.json';
import internalEn from '@/locales/en/internal.json';
import profileEn from '@/locales/en/profile.json';
import commonFr from '@/locales/fr/common.json';
import campaignFr from '@/locales/fr/campaign.json';
import errorFr from '@/locales/fr/error.json';
import faqFr from '@/locales/fr/faq.json';
import validationFr from '@/locales/fr/validation.json';
import poweredFr from '@/locales/fr/powered.json';
import marketingFr from '@/locales/fr/marketing.json';
import glossaryFr from '@/locales/fr/glossary.json';
import tableFr from '@/locales/fr/table.json';
import internalFr from '@/locales/fr/internal.json';
import profileFr from '@/locales/fr/profile.json';
import commonKm from '@/locales/km/common.json';
import campaignKm from '@/locales/km/campaign.json';
import errorKm from '@/locales/km/error.json';
import faqKm from '@/locales/km/faq.json';
import validationKm from '@/locales/km/validation.json';
import poweredKm from '@/locales/km/powered.json';
import marketingKm from '@/locales/km/marketing.json';
import glossaryKm from '@/locales/km/glossary.json';
import tableKm from '@/locales/km/table.json';
import internalKm from '@/locales/km/internal.json';
import profileKm from '@/locales/km/profile.json';
export const defaultNS = 'common';
export const resources = {
    en: {
        campaign: campaignEn,
        common: commonEn,
        error: errorEn,
        faq: faqEn,
        glossary: glossaryEn,
        internal: internalEn,
        marketing: marketingEn,
        powered: poweredEn,
        profile: profileEn,
        table: tableEn,
        validation: validationEn,
    },
    fr: {
        campaign: campaignFr,
        common: commonFr,
        error: errorFr,
        faq: faqFr,
        glossary: glossaryFr,
        internal: internalFr,
        marketing: marketingFr,
        powered: poweredFr,
        profile: profileFr,
        table: tableFr,
        validation: validationFr,
    },
    km: {
        campaign: campaignKm,
        common: commonKm,
        error: errorKm,
        faq: faqKm,
        glossary: glossaryKm,
        internal: internalKm,
        marketing: marketingKm,
        powered: poweredKm,
        profile: profileKm,
        table: tableKm,
        validation: validationKm,
    },
};
i18next
    .use(initReactI18next)
    .init({
    cleanCode: true,
    compatibilityJSON: 'v4',
    defaultNS,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    lng: localStorage.getItem('adora_lang') || 'en',
    ns: [
        'campaign',
        'common',
        'error',
        'faq',
        'glossary',
        'internal',
        'marketing',
        'powered',
        'profile',
        'table',
        'validation',
    ],
    resources,
    supportedLngs: ['en', 'fr', 'km'],
})
    .then();
export default i18next;
